import { Button } from "antd";
import { useCallback } from "react";
import { BatchModal } from "../BatchModal";

type CreateBatchBtnProps = {
  id: string | null;
  isOpenEditModal: boolean;
  setId: React.Dispatch<React.SetStateAction<string | null>>;
  setIsOpenEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  reloadData: () => void;
};

export const CreateBatchBtn = ({
  id,
  isOpenEditModal,
  setId,
  setIsOpenEditModal,
  reloadData,
}: CreateBatchBtnProps) => {
  const onCreateClick = useCallback(
    () => setIsOpenEditModal(true),
    [setIsOpenEditModal]
  );

  return (
    <>
      <Button
        shape="round"
        type="primary"
        className="ml-4"
        onClick={onCreateClick}
      >
        Create Batch
      </Button>

      <BatchModal
        isOpen={isOpenEditModal}
        setIsOpen={setIsOpenEditModal}
        id={id}
        onEditSuccess={reloadData}
        setId={setId}
      />
    </>
  );
};
